module.exports = __webpack_public_path__ + "img/arrow_white_down.c599138.png";